import OrderFinancingType from "@/module/main/dto/OrderFinancingTypeEnum";
import IOrderFinancing from "@/module/main/dto/IOrderFinancing";
import IInstallmentSettings from "@/module/main/dto/IInstallmentSettings";
import IOperatingLeaseSettings from "@/module/main/dto/IOperatingLeaseSettings";
import IAmount from "@/module/main/dto/IAmount";

export default class OrderFinancing implements IOrderFinancing
{
    constructor(
        public type: OrderFinancingType = OrderFinancingType.INSTALLMENT,
        public amount: IAmount | undefined,
        public installment: IInstallmentSettings | undefined,
        public operatingLease: IOperatingLeaseSettings | undefined,
    )
    {
    }
}
